export const notAllowedDocumentNameCharactersRegex = /[\/:*?\"\<\>\|\\]/g;
